import styled from 'styled-components'

const darkText = '#333'
const lightText = '#FFF'
const mainColor = 'var(--main-color)'

interface UserMenuStyledProps {
  $themedark?: boolean
  $collapsemenu?: boolean
}

export const UserMenuStyled = styled.div<UserMenuStyledProps>`
  .ant-menu-item-selected,
  .ant-menu-submenu-selected > .ant-menu-submenu-title {
    font-weight: 600 !important;
  }

  /* Tùy chỉnh thanh cuộn cho nhỏ lại */
  &::-webkit-scrollbar,
  .side-bar-wrapper::-webkit-scrollbar,
  .ant-menu::-webkit-scrollbar {
    width: 1px;
    height: 1px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #d9d9d9;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #bfbfbf;
  }
`
